import { sortAlphabeticByAttribute } from '@app/utils';
import {
  APPLICATION_AND_MATERIAL_FACET_ID,
  UOM
} from '@app/constants/commonConstants';
import { hasBothMetricAndUSSpecs } from '../products/utils';
export const normalizeHashFacets = facets =>
  facets.map(item => item.value.map(innerItem => innerItem.facet)).flat();

export const getUrlByHashValue = (value, widgetId, hash) => {
  let orderByValue = `${value}|${widgetId}`;
  let finalHashValue = '';
  if (hash && hash.includes(widgetId)) {
    hash.split(',').forEach(item => {
      if (item.includes(widgetId)) {
        finalHashValue += finalHashValue ? `,${orderByValue}` : orderByValue;
      } else {
        finalHashValue += finalHashValue ? `,${item}` : item;
      }
    });
  }
  if (finalHashValue) {
    return finalHashValue;
  } else {
    return hash ? `${hash},${orderByValue}` : orderByValue;
  }
};

/**
 * Function format the facets array when these comes with a dash (subcategories)
 * @param {{facet: string, label: string, count: number}[]} facets array of facets
 * @returns Array with formated facets
 */
export const handleSubspecifications = (facets, values, initialRender) => {
  if (!initialRender) {
    return facets;
  }

  const sortedFacets = sortAlphabeticByAttribute(facets, 'label');
  const subspecifications = [
    ...new Set(sortedFacets.map(({ label }) => label.split(' - ')[0]))
  ];
  return subspecifications.map(subspecificationValue => ({
    label: subspecificationValue,
    values: sortedFacets
      .filter(({ label }) => {
        return label.split(' - ')[0] === subspecificationValue;
      })
      .map(({ count, facet, label }) => {
        const val = values.find(({ facet: facetId, label }) => {
          if (facetId == facet) {
            return {
              count,
              facet,
              label: label.split(' - ')[1] ?? label.split(' - ')[0]
            };
          }
        });
        return val
          ? { ...val, label: label.split(' - ')[1] ?? label.split(' - ')[0] }
          : {
              count: 0,
              facet,
              label: label.split(' - ')[1] ?? label.split(' - ')[0]
            };
      })
  }));
};

export const marketingNormalizeCategoryDetails = (
  data,
  facets,
  initialRender
) => {
  return {
    ...data,
    showSpecificationsToggle: facets ? hasBothMetricAndUSSpecs(facets) : false,
    facets: sortAlphabeticByAttribute(facets, 'label').map(facet => {
      const { facetDisabled, facetValues } = isFacetDisabled(
        facet,
        data?.facets
      );
      if (facet.facetId === APPLICATION_AND_MATERIAL_FACET_ID) {
        return {
          ...facet,
          isSubspecification: true,
          value: handleSubspecifications(
            facet.value,
            facetValues,
            initialRender
          )
        };
      }

      return {
        ...facet,
        facetGroupShouldBeDisabled: facetDisabled,

        value: sortAlphabeticByAttribute(facet.value, 'label').map(
          ({ facet: subfacet, label }) => {
            const value = facetValues.find(({ facet: facetId, count }) => {
              if (facetId == subfacet) {
                return {
                  count,
                  facet: subfacet,
                  label,
                  uom: facet.uom ?? UOM.null
                };
              }
            });

            return value
              ? { ...value, uom: facet.uom ?? UOM.null }
              : {
                  count: 0,
                  facet: subfacet,
                  label,
                  uom: facet.uom ?? UOM.null
                };
          }
        )
      };
    })
  };
};

export const isFacetDisabled = (facet, facets) => {
  let facetDisabled = true;

  let facetValues = facet.value;
  facets?.forEach(item => {
    if (item.facetId == facet.facetId) {
      facetDisabled = false;
      facetValues = item.value;
    }
  });
  return { facetDisabled, facetValues };
};
